"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiPayStubs {
    static getLatest(token, count) {
        let url = `/paystub/latest?count=${count}&client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
    static getList(token, year) {
        let url = `/paystub/list?year=${year}&client=${token.client}`;
        return Client_1.default.httpGet(url, token)
            .then((data) => data?.paystubs);
    }
    static getDetail(token, id) {
        let url = `/paystub/get?id=${id}&client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
    static getDownload(token, id) {
        let url = `/paystub/download?id=${id}&client=${token.client}`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiPayStubs;
